import { axiosClient as axios } from './axiosClient';

import {
  failureResult,
  ResultViewModel,
  successResult,
} from '@models/common/ResultViewModel';
import {
  ContactResultViewModel,
  ContactTableResultViewModel,
  ContactViewModel,
} from '@models/Contact';
import { handleAxiosError } from '@utils/axiosErrorHandler';
import { getDataUrl } from '@utils/dataUrls';
import { api } from 'src/config/apiEndpoints';

export const ContactService = {
  create: async function (
    contact: ContactViewModel
  ): Promise<ContactResultViewModel | ResultViewModel> {
    const createUrl = `${api.BASE_URL}${api.CONTACTS_ENDPOINT}`;

    try {
      const response = await axios.post(createUrl, contact);
      return response.data as ContactResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getList: async function (
    page?: number,
    pageSize?: number,
    searchFields?: string,
    search?: string,
    filters?: string,
    sortBy?: string,
    sortDirection?: string
  ): Promise<ContactTableResultViewModel | ResultViewModel> {
    let dataUrl = getDataUrl(
      api.BASE_URL,
      api.CONTACTS_ENDPOINT,
      page,
      pageSize,
      searchFields,
      search,
      sortBy,
      sortDirection
    );
    if (filters) {
      dataUrl = dataUrl + filters;
    }

    try {
      const response = await axios.get(dataUrl);
      return response.data as ContactTableResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getById: async function (
    id: number
  ): Promise<ContactResultViewModel | ResultViewModel> {
    const dataUrl = `${api.BASE_URL}${api.CONTACTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as ContactResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  update: async function (
    id: number,
    contact: ContactViewModel
  ): Promise<ResultViewModel> {
    const updateUrl = `${api.BASE_URL}${api.CONTACTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.put(updateUrl, contact);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  delete: async function (id: number): Promise<ResultViewModel> {
    const deleteURL = `${api.BASE_URL}${api.CONTACTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.delete(deleteURL);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  isContactEmailInUse: async function (
    email: string,
    contactId?: number
  ): Promise<boolean> {
    const checkContactEmailUrl = `${api.BASE_URL}${api.CONTACTS_ENDPOINT}/is-contact-email-in-use`;

    try {
      const response = await axios.get(checkContactEmailUrl, {
        params: { email, excludeId: contactId },
      });
      return response.data;
    } catch (error) {
      return true; // If there's an error, assume the email is in use
    }
  },
};
